module.exports = __webpack_public_path__ + "img/ic_nav_share.35139bbd.svg";